import React, {Component} from 'react';
import PropTypes from "prop-types";
import SoftwareVideoListContainer from "./SoftwareVideoListContainer";
import SoftwareVideoCategoryContainer from "./SoftwareVideoCategoryContainer";
import Api from "../../utils/Api";
import ModuleNav from "../../mainFrame/ModuleNav";

class SoftwareContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    static defaultProps = {
        videoSource: 'YouTube',
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            selectedVideoCategory: null,
            categoryList: null,
            videoList: null,
        };

        this.translate = this.props.baseData.translate;

        this.requestSoftwareCategories = this.requestSoftwareCategories.bind(this);
        this.requestSoftwareVideos = this.requestSoftwareVideos.bind(this);
        this.setSelectedVideoCategory = this.setSelectedVideoCategory.bind(this);
        this.resetSelectedVideoCategory = this.resetSelectedVideoCategory.bind(this);

    }

    componentWillMount() {

        this.requestSoftwareCategories();
        this.requestSoftwareVideos();

    }

    requestSoftwareCategories() {

        const params = {
            companyId: this.props.baseData.companies.currentCompany.id,
            filter: {}
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    categoryList: res,
                });
            }
        }.bind(this);

        this.api.request('GetSoftwareVideoCategories', params, callback, null);

    }

    requestSoftwareVideos() {

        const params = {
            companyId: this.props.baseData.companies.currentCompany.id,
            filter: {}
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    videoList: res,
                });
            }
        }.bind(this);

        this.api.request('GetSoftwareVideos', params, callback, null);

    }

    setSelectedVideoCategory(videoCategory) {

        this.setState({
            selectedVideoCategory: videoCategory,
        });

    }

    resetSelectedVideoCategory() {

        this.setState({
            selectedVideoCategory: null,
        });

    }

    getVideoCategoryName() {

        let categoryActive = this.props.videoSource;
        let categories = this.state.categoryList;

        if (typeof categories !== 'undefined' && categories) {
            if (typeof categories['category-' + categoryActive] !== 'undefined') {
                let categorysTemp = categories['category-' + categoryActive];

                for (let i = 0; i < categorysTemp.length; i++) {
                    if (categorysTemp[i]['category_id'] === this.state.selectedVideoCategory) {
                        return categorysTemp[i]['category_name'];
                    }
                }
            }
        }

        return null;

    }

    render() {
        //const downloadLink = (this.props.baseData.userData.language === 'de') ? 'https://www.zsk.de/de/software/my-zsk.php' : 'https://www.zsk.de/en/software/my-zsk.php';
        const downloadLink = 'https://shop.zsk.de/product/datacollector-software/';

        return (
            <div className="alarmContainer">
                <div className="ma-bo-20 clearfix">
                    <nav>
                        <h1>{this.translate('software')}</h1>
                    </nav>

                    <div>
                        <p>{this.translate('downloadDcSoftware')}</p>
                    </div>

                    <div className="bottomLinks clearfix">
                        <a className="prewLink" href={downloadLink} target="_blank" style={{fontWeight: 600}}>{this.translate('download')}</a>
                    </div>
                </div>
            </div>
        );

    }

    renderSave() {

        const selectedVideoCategory = this.state.selectedVideoCategory;

        if (selectedVideoCategory) {
            return (
                <SoftwareVideoListContainer
                    {...this.props}
                    videoSource={this.props.videoSource}
                    videoList={this.state.videoList}
                    activeVideoCategory={selectedVideoCategory}
                    activeVideoCategoryName={this.getVideoCategoryName()}
                    onClick={this.resetSelectedVideoCategory}
                />
            );
        } else {
            return (
                <SoftwareVideoCategoryContainer
                    {...this.props}
                    categoryList={this.state.categoryList}
                    videoSource={this.props.videoSource}
                    onClick={this.setSelectedVideoCategory}
                />
            );
        }

    }

}

export default SoftwareContainer;